module.exports = __webpack_public_path__ + "static/intertec_product_3-55465517c6acae14d39eb3e8ed80d41e.avif";